'use client'

import { Alert as HerouiAlert } from '@heroui/alert'
import { useAlert } from './use-alert'

type Props = {
  error?: string
  message?: string
  timeout?: number | null
}

export const Alert: React.FC<Props> = ({ error, message, timeout }) => {
  const { shown, onClose } = useAlert({
    showMessageCondition: Boolean(error || message),
    timeout,
  })

  if (!shown) {
    return null
  }
  return (
    <HerouiAlert
      isClosable
      onClose={onClose}
      className='mt-4'
      variant='flat'
      hideIcon
      color={error ? 'danger' : 'success'}
      title={error ? error : message}
    />
  )
}
